//export const ServiceAPI = 'http://localhost:5000/api';
export const ServiceAPI = 'https://api.drinkwine.co.za/api';